import { render, staticRenderFns } from "./ModalEditTotalSeats.vue?vue&type=template&id=d87fc52a"
import script from "./ModalEditTotalSeats.vue?vue&type=script&lang=js"
export * from "./ModalEditTotalSeats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports